// Constantes relacionadas à API

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_MCP_API_BASE_URL || "http://localhost:3002",
  TIMEOUT: parseInt(import.meta.env.VITE_MCP_API_TIMEOUT || "30000"),
  DEFAULT_HEADERS: {
    "Content-Type": "application/json",
  },
} as const;

export const API_ENDPOINTS = {
  HEALTH: "/api/health",
  CHAT: {
    SESSION: "/api/chat/session",
    MESSAGE: "/api/chat/message",
    HISTORY: (sessionId: string) => `/api/chat/history/${sessionId}`,
    DELETE_SESSION: (sessionId: string) => `/api/chat/session/${sessionId}`,
    DELETE_ALL_SESSIONS: "/api/chat/sessions",
  },
  TOOLS: {
    LIST: "/api/tools",
    EXECUTE: "/api/tools/execute",
  },
  RESOURCES: "/api/resources",
  PROMPTS: "/api/prompts",
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const;

export const API_ERROR_MESSAGES = {
  NETWORK_ERROR: "Erro de conexão com o servidor",
  TIMEOUT_ERROR: "Tempo limite da requisição excedido",
  UNKNOWN_ERROR: "Erro desconhecido",
  API_ERROR: "Erro na API",
} as const;
